import { delay } from "./delay";

export async function promiseWithMinimumDelay<T>(
  promise: Promise<T>,
  minimumDelay: number,
): Promise<T> {
  const [result] = await Promise.all([promise, delay(minimumDelay)]);
  return result;
}
